import {Injectable}					      from '@angular/core';
import {Http, Response}				    from '@angular/http';
import {Headers, RequestOptions}	from '@angular/http';
import {City}				      from './city';
import { Street }				from './street';
import {Observable}					      from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/from';
//import 'rxjs/add/operator/publish';
import { environment } from '../environments/environment';
import { ConfigService } from './config.service';

import { Step1Data } from './step1-calc/Step1-DataModel';
import { Step2Data } from './step2-calc/Step2-DataModel';

import { isEligibleResult} from './isEligibleResult';

@Injectable()
export class ContentService {
	constructor(private http: Http, private configService: ConfigService) {
		this.citiesList = [];
	}

	public _config = this.configService.getConfiguration();
	public _baseUrl = this._config.webApiBaseUrl;
    public _citiesListUrl = //'http://localhost:54432/govil/apps/he/kabaut/shalhevet/';
		this._baseUrl + 'getCitiesList';
    public _streetsListUrl = 
		this._baseUrl + 'getStreetsForCity';
	public _isStep1EligibleUrl =
		this._baseUrl + 'isStep1Eligible';
	public _isStep2EligibleUrl =
		this._baseUrl + 'isStep2Eligible';
	public _isTestData = this._config.isTestData;

	citiesList: City[];

	getCitiesList () {
		///debugger;
		if (this.citiesList.length <= 0) {
			return this.http.get(this._citiesListUrl + (this._isTestData ? '/Test' : ''))
				.map(res => (this.citiesList =
					<City[]>res.json()).filter(
					(node, ix, nodes) => {
						if (node) // dummy check
							return true;
					}))
				.do(data => {
					//console.log(data);
				})
				.catch(this.handleError);


		}
		else {
			return Observable.from([this.citiesList]);
		}
			
	}

	getStreets4City(city) {
		///debugger;
		return this.http.get(this._streetsListUrl + '/' + city + (this._isTestData ? '/Test' : ''))
				.map(res => (
					<Street[]>res.json()).filter(
					(node, ix, nodes) => {
						if (node) // dummy check
							return true;
					}))
				.do(data => {
					//console.log(data);
				})
				.catch(this.handleError);

	}

	isStep1Eligible(step1Data: Step1Data) {
		///debugger;
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		return this.http.post(this._isStep1EligibleUrl + (this._isTestData ? '/Test' : ''),
			JSON.stringify(step1Data), { headers: headers })
			.map(res => 
				//<boolean>res.json()
				(<isEligibleResult>res.json())
			)
			.do(data => {
				//console.log(data);
			})
			.catch(this.handleError);
	}

	isStep2Eligible(step2Data: Step2Data) {
		///debugger;
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		return this.http.post(this._isStep2EligibleUrl + (this._isTestData ? '/Test' : ''),
			JSON.stringify(step2Data), { headers: headers })
			.map(res =>
				//<boolean>res.json()
				(<isEligibleResult>res.json())
			)
			.do(data => {
				//console.log(data);
			})
			.catch(this.handleError);
	}

	private handleError(error: Response) {
		if (error)
			console.error(error);
		return Observable.throw(error && error.json && error.json().error || 'תקלת אינטרנט');
	}
}


// WEBPACK FOOTER //
// ./src/app/content.service.ts